import { gql } from "@apollo/client";














export const UPDATE_NOTIFICATION_SCHEDULE = gql`
  mutation updateNotificationSchedule($input: updateNotificationScheduleInput) {
    updateNotificationSchedule(input: $input)
  }
`;
